export default __webpack_public_path__ + "static/media/Flag_of_Japan.d98ffc0c.svg";